import { getAirbrake } from "@simplybusiness/services";
import {
  AIRBRAKE_PROJECT_ID,
  AIRBRAKE_PROJECT_KEY,
} from "../constants/constants";

export const getInterventionsAirbrake = () =>
  getAirbrake({
    projectId: AIRBRAKE_PROJECT_ID,
    projectKey: AIRBRAKE_PROJECT_KEY,
  });
